"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 修改可提现金额
 */
var _default = exports.default = {
  props: {
    // 1 代理 2 商户
    type: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      //可提现金额
      editWithDialog: false,
      withList: [],
      reducingList: [],
      available_withdraw_money: 0,
      editWith: {},
      setRow: {},
      activeTab: '修改记录',
      tabs: ['修改记录', '扣减记录']
    };
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 显示dialog
     */
    showDialog: function showDialog(row) {
      this.editWithDialog = true;
      this.setRow = row;
      this.editWith.son_id = row.aid;
      this.getList(row.aid);
    },
    /**
     * 获取修改记录
     */
    getList: function getList(id) {
      var _this = this;
      this.$get('agentapi/business/modify_agent_accout', {
        son_id: id
      }).then(function (res) {
        _this.withList = res.list;
        _this.reducingList = res.reducing_list;
        _this.available_withdraw_money = res.available_withdraw_money;
      });
    },
    /**
     * 获取修改记录
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      this.loadObj = this.$loading({
        lock: true,
        text: '正在提交',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/business/modify_agent_accout', this.editWith).then(function (res) {
        if (_this2.type == 2) {
          _this2.setRow.available_withdraw_money = (0, _index.accAdd)(_this2.setRow.available_withdraw_money, _this2.editWith.money);
        } else {
          _this2.setRow.money = (0, _index.accAdd)(_this2.setRow.money, _this2.editWith.money);
        }
        _this2.editWithDialog = false;
        _this2.editWith = {};
        _this2.loadObj.close();
        _this2.$message({
          message: '修改成功',
          type: 'success'
        });
      }).catch(function (err) {
        _this2.loadObj.close();
      });
    }
  }
};